import React, { useState } from "react";
import CustomModal from "../Common/CustomModal";
import { Box } from "@mui/material";
import { CustomBtn } from "../Common/CustomBtn";
import ImageUploadInput from "../Common/ImageUploadInput";
import axiosInstance from "../../utils/config/config";

const AddPhotoModal = ({ open, onClose, onCreated, setErrorState }) => {
  const [image, setImage] = useState(null);

  const handleSave = async () => {
    if (!image) {
      setErrorState({
        error: true,
        errorMsg: "Please select a photo",
      });
      return;
    }

    try {
      await axiosInstance.post("/gallery/addPhoto", { image_url: image });
      setImage(null);
      onClose();
      onCreated?.();
    } catch (error) {
      setErrorState({
        error: true,
        errorMsg: error?.response?.data?.message || "Failed to add photo",
      });
    }
  };

  return (
    <CustomModal open={open} onClose={onClose} title="Add Photo">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "50%",
          margin: "0 auto",
        }}
      >
        <ImageUploadInput
          image={image}
          setImage={setImage}
          width={"100%"}
          height={"220px"}
          label={"Photo"}
        />

        <CustomBtn
          text={"Save"}
          width={"100%"}
          height={"50px"}
          mt={2}
          mb={2}
          onClick={handleSave}
        />
      </Box>
    </CustomModal>
  );
};

export default AddPhotoModal;
